import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { JobService } from './job-service/job.service';
import { JobsListModel } from './job-service/models/JobsListModel';
import { SortDefinition } from '../shared/models/SortDefinition';
import { SortDirection } from '../shared/models/SortDirection';
import { JobRequest } from './job-service/models/JobRequest';
import { VisibilityTypes } from './job-service/models/JobListModel';

@Injectable({
  providedIn: 'root'
})
export class JobsResolver implements Resolve<JobsListModel> {

  constructor(private service: JobService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<JobsListModel> {
    const internalJobBoardIdentifier = route.paramMap.get('jobBoardIdentifier');
    const isInternal = internalJobBoardIdentifier !== null;
    const sortField = !isInternal ? 'PostedDate' : 'InternalPostedDate';
    
    const request: JobRequest = Object.assign(new JobRequest(), route.queryParams);
    request.subBrandIdentifier = route.paramMap.get('subBrandIdentifier');
    request.getFacets = true;
    request.filter = {};
    
    if (!isInternal) {
      request.visibilityType = VisibilityTypes.External;
    } else {
      request.visibilityType = VisibilityTypes.Internal;
      request.internalJobBoardIdentifier = internalJobBoardIdentifier;
    }

    request.sort = request.sort ? request.sort : new SortDefinition(sortField, SortDirection.Desc);

    return this.service.getJobs(request);
  }
}
